import { first } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BriefingService } from '../services';

import  * as _ from 'lodash';
import * as moment from 'moment';

@Component({
    styles: [`
        briefing-preview {
            height: calc(100vh - 280px);
            max-width: 80vw;
            overflow-y: hidden;
            padding-top: 15px;
        }
    `],
    template: `
    <div fxLayout="column">
        <mat-toolbar color="primary" id="picker-menu">
            <h2>Preview Briefing</h2>
        </mat-toolbar>
        <div fxLayout="column" fxLayoutAlign="center center" *ngIf="noTouching"><spinner style="padding-top: 30px;"></spinner></div>
        <div fxLayout="column" fxLayoutAlign="center center" *ngIf="!noTouching && !briefing">
            <h3 style="padding-top: 30px;">The briefing you are trying to find does not exist.</h3>
            <button mat-button [routerLink]="['/briefings']">Briefing List</button>
        </div>
        <div fxLayout="column" fxFlex="100" *ngIf="!noTouching && briefing" fxLayoutAlign="space-around stretch">
            <div fxLayout="row" fxLayoutAlign="space-around center">
                <div fxFlex style="overflow-x: hidden;">
                    <h3 class="title">{{briefing.briefingTitle}}</h3>
                    <p>Schedule: {{scheduleDescription(briefing.schedule)}}</p>
                    <p class="description">{{briefing.description}}</p>
                </div>
                <div fxFlex="15" fxLayoutAlign="center center">
                    <button mat-raised-button color="primary" [routerLink]="['../subscribe']">Subscribe</button>
                </div>
            </div>
            <briefing-preview fxFlexOffset="10" [briefingId]="briefing.id" [visible]="true"></briefing-preview>
        </div>
    </div>
    `
})
export class BriefingSubscribePreviewComponent implements OnInit {
    noTouching: boolean = true;
    briefing: any;
    repeatModes = [
        { key: 'HOURLY', val: 'Hourly'},
        { key: 'DAILY', val: 'Daily'},
        { key: 'EVERY_WEEKDAY', val: 'Every weekday (Monday to Friday)'},
        { key: 'EVERY_MON_WED_FRI', val: 'Every Monday, Wednesday and Friday'},
        { key: 'EVERY_TUE_THUR', val: 'Every Tuesday and Thursday'},
        { key: 'WEEKLY', val: 'Weekly'},
        { key: 'BIWEEKLY', val: 'Bi-weekly'},
        { key: 'MONTHLY', val: 'Monthly'}
    ];
    byDay = {
        'SU': 'Sunday',
        'MO': 'Monday',
        'TU': 'Tuesday',
        'WE': 'Wednesday',
        'TH': 'Thursday',
        'FR': 'Friday',
        'SA': 'Saturday'
    };

    constructor(private route: ActivatedRoute, private briefingService: BriefingService) {}

    ngOnInit(): void {
        this.noTouching = true; 
        this.briefingService.getUnauthBriefings({}).pipe(first())
        .subscribe(briefingsResponse => {
            this.briefing = _.find(briefingsResponse.content, {id: this.route.snapshot.params.briefingId });
            this.noTouching = false;
        });    
    }

    scheduleDescription = schedule => {
        let desc;
        if (schedule && schedule.scheduleMode === 'MANUAL') {
            desc = 'Manual';
        } else if (schedule && schedule.scheduleMode === 'RECURRING') {
            const key = schedule.freq === 'WEEKLY' && schedule.interval === 2 ? 'BIWEEKLY' : schedule.freq;
            desc = _.find(this.repeatModes, { key }).val;
            if (schedule.freq === 'WEEKLY' && schedule.byday) {
                desc = desc + ' on ' + schedule.byday.map(byday => this.byDay[byday]).join(', ');
            }

            if (schedule.freq !== 'HOURLY' && schedule.nextScheduledDate) {
                desc = desc + ' at ' + moment(schedule.nextScheduledDate).format('h:mm a');
            }
        }
        return desc || '';
    }
}